import NotFooterLayout from "layouts/NotFooterLayout";
import CreditTopupPage from "components/ManageCredit/CreditTopupPage";

function ManageCreditTopupPage() {
  return (
    <NotFooterLayout namePage="เติมเครดิต">
      <div className="layout-content">
        <CreditTopupPage />
      </div>
    </NotFooterLayout>
  );
}

export default ManageCreditTopupPage;
